import * as Popover from "@radix-ui/react-popover";
import { Maximize2, X } from "lucide-react";
import { tableReadabilityCopy } from "./tableReadability";
import "./tableReadability.css";

// A compact cell keeps its original value; the full value opens without a fetch.
export default function TableFullText({ text, label, language }: { text: string; label: string; language: string }) {
  const c = tableReadabilityCopy(language);
  if (!text || text === "—") return <span>{text}</span>;
  return <Popover.Root><span className="table-full-text-trigger">
    <span>{text}</span><Popover.Trigger asChild><button type="button"
      aria-label={`${label}: ${text} · ${c.open}`} title={c.open}
      onClick={event => event.stopPropagation()} onKeyDown={event => { if (event.key === "Enter" || event.key === " ") event.stopPropagation(); }}>
      <Maximize2 size={13} aria-hidden="true" />
    </button></Popover.Trigger></span>
    <Popover.Portal><Popover.Content className="table-full-text-panel" role="dialog" aria-label={`${label} · ${c.title}`}
      sideOffset={6} collisionPadding={12} onEscapeKeyDown={event => event.stopPropagation()}>
      <p>{text}</p><Popover.Close asChild><button type="button" aria-label={c.close}><X size={16} aria-hidden="true" /></button></Popover.Close>
    </Popover.Content></Popover.Portal>
  </Popover.Root>;
}
